import React, { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Tooltip,
  IconButton
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import RefreshIcon from '@material-ui/icons/Refresh'
import { useJiraBoardAdmininstrator } from './useJiraBoardAdministrator'
import service from './JiraResourcesService'

export function JiraBoardAdministrator({ projectKey }: { projectKey: string }) {
  const [reloadCounter, setReloadCounter] = useState(0)
  const admin = useJiraBoardAdmininstrator(projectKey, reloadCounter)
  const [updateClicked, setUpdateClicked] = useState(false)
  const [updating, setUpdating] = useState(false)

  function onUpdate(): void {
    setUpdateClicked(true)
    setUpdating(true)
    service
      .putBoardAdministrator(projectKey)
      .catch(() => {})
      .finally(() => {
        setUpdating(false)
        setReloadCounter(reloadCounter + 1)
      })
  }

  const status = (
    <span style={{ marginRight: 8, verticalAlign: 'middle' }}>
      {typeof admin === 'undefined' ? (
        <CircularProgress size={16} style={{ marginLeft: 8 }} />
      ) : admin === null ? (
        <Tooltip title='Failed to load board administrator'>
          <ClearIcon style={{ color: 'red' }} />
        </Tooltip>
      ) : admin?.actual === admin?.expected ? (
        <Tooltip title='Standandard administrator'>
          <CheckIcon style={{ color: 'green' }} />
        </Tooltip>
      ) : (
        <Tooltip title='Non standandard administrator'>
          <ClearIcon style={{ color: 'red' }} />
        </Tooltip>
      )}
    </span>
  )

  return (
    <Box>
      {status}
      Board administrator:{' '}
      <IconButton
        disabled={updating || typeof admin === 'undefined'}
        onClick={() => setReloadCounter(reloadCounter + 1)}
        style={{ marginLeft: 8 }}
      >
        <RefreshIcon />
      </IconButton>
      {admin ? (
        <span>
          {admin?.actual}{' '}
          {admin?.actual === admin?.expected ? null : (
            <Button
              variant='text'
              color='primary'
              disabled={updateClicked}
              onClick={() => onUpdate()}
            >
              Update
              {updating ? (
                <CircularProgress size={16} style={{ marginLeft: 8 }} />
              ) : null}
            </Button>
          )}
        </span>
      ) : null}
    </Box>
  )
}
